export const shutdowns_fetchStart = 'shutdowns/fetchStart';
export const shutdowns_fetchSuccess = 'shutdowns/fetchSuccess';
export const shutdowns_fetchError = 'shutdowns/fetchError';
